<template>
  <svg
    width="15"
    height="19"
    viewBox="0 0 15 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="st1"
      d="m11.37501,6.375l0,10l-8,0l0,-10l8,0m-1.5,-6l-5,0l-1,1l-3.5,0l0,2l14,0l0,-2l-3.5,0l-1,-1zm3.5,4l-12,0l0,12c0,1.1 0.9,2 2,2l8,0c1.1,0 2,-0.9 2,-2l0,-12z"
    />
  </svg>
</template>

<script>
export default {
  name: 'TrashIcon',
};
</script>
<style scoped lang="scss">
svg {
  display: inline-flex;
  &:hover {
    cursor: pointer;
  }
}
.st1 {
  fill: main.$npGray;
}
</style>
